import { render, staticRenderFns } from "./log.vue?vue&type=template&id=12478e52&scoped=true"
import script from "./log.vue?vue&type=script&lang=ts"
export * from "./log.vue?vue&type=script&lang=ts"
import style0 from "./log.vue?vue&type=style&index=0&id=12478e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12478e52",
  null
  
)

export default component.exports